import React from 'react';
import { formatEUR } from '../../../constants/tool.fn';
import i18n from '../../../i18n';
import { MenuSalesRow } from './state/dish-data-shared.types';
import SalesCompareDialog, { SalesCompareDialogItem } from './sales-compare-dialog';

/** 组件属性。 */
interface DishSalesCompareDialogProps {
    /** 弹窗开关。 */
    open: boolean;
    /** 关闭弹窗。 */
    onClose: () => void;
    /** 当前选中的菜品销售行。 */
    rows: MenuSalesRow[];
}

/**
 * 生成对比项展示名称，用于菜单标题、折线图图例和饼图图例。
 * @param row - 当前行
 * @returns 展示名称
 */
function getRowDisplayName(row: MenuSalesRow) {
    return row.item_name1 || row.category_name || row.menu_name || `#${row.id}`;
}

/**
 * 菜品销售对比弹窗。
 */
function DishSalesCompareDialog({ open, onClose, rows }: DishSalesCompareDialogProps) {
    /** 对比项映射。 */
    const compareItems: SalesCompareDialogItem[] = rows.map((row) => ({
        key: row.rowKey,
        label: getRowDisplayName(row),
        amount: formatEUR(Number(row.total_amount ?? 0)),
        total_amount: row.total_amount,
        total_quantity: Number(row.total_quantity ?? row.sum_quantity ?? 0),
        quantity: String(Number(row.total_quantity ?? row.sum_quantity ?? 0)),
        ratio: Number(row.sales_ratio ?? 0),
        curve: (row.quantity_curve ?? []).map((point) => ({
            x: point.x,
            y: Number(point.y ?? 0),
        })),
    }));
    /** 当前对比项名称集合，用于判断是否可以显示单一菜单标题。 */
    const compareNameList = rows.map((row) => getRowDisplayName(row));
    /** 是否全部为同一名称的对比数据。 */
    const isSingleCompareName = new Set(compareNameList).size === 1;
    /** 弹窗内展示的菜单标题。 */
    const dialogMenuTitle = (isSingleCompareName ? compareNameList[0] : i18n.t('business_analysis_page_text_data_compare')).toUpperCase();

    return (
        <SalesCompareDialog
            open={open}
            onClose={onClose}
            items={compareItems}
            title={i18n.t('group_revenue_analysis_menu_revenue_chart')}
            lineChartTitle={dialogMenuTitle}
        />
    );
}

export default DishSalesCompareDialog;
